import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoriesSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <p className="text-sm text-primary-500 font-medium mb-3 tracking-wide">内容分类</p>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            探索您感兴趣的内容
          </h2>
          <p className="text-foreground-600 max-w-[560px] mx-auto leading-relaxed">
            六大内容分类，覆盖从入门到精通的全部学习路径，从新手到专家，17c陪您成长。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex items-start gap-4 p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-md shrink-0 ${
                cat.color === 'accent' ? 'bg-accent-100 text-accent-500 group-hover:bg-accent-500 group-hover:text-background-50' :
                cat.color === 'secondary' ? 'bg-secondary-100 text-secondary-500 group-hover:bg-secondary-500 group-hover:text-background-50' :
                'bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50'
              } transition-all duration-300`}>
                <i className={`${cat.icon} text-lg`} />
              </div>
              <div>
                <h3 className="text-base font-heading font-semibold text-foreground-950 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-2">{cat.description}</p>
                <span className="text-xs text-foreground-400">{cat.articleCount} 篇文章</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}